export default "__VITE_ASSET__CUpp5I29__"